import React, { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Homepage1 from "./components/Homepage1";
import Homepage2 from "./components/Homepage2";
import Homepage3 from "./components/Homepage3";
import Footer from "./components/Footer";
import Bookings from "./components/Bookings";
import AuthForm from "./components/Auth.jsx";
import { ToastContainer } from "react-toastify";
import AdminRoute from "./components/AdminRoute.jsx";
import AdminDashboard from "./components/AdminDashboard.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import AboutUs from "./pages/AboutUs.jsx";
import EmailVerificationStatus from "./components/EmailVerificationStatus.jsx";
import { useAuth } from "./context/AuthContext.jsx";
import ForgetPassword from "./components/ForgetPassword.jsx";
import ContactQueryModal from "./components/ContactQueryModal.jsx";
import FullScreenLoader from "./components/FullScreenLoader.jsx";
import UserProfile from "./components/UserProfile.jsx";
import ActivityBooking from "./components/ActivityBookingPage.jsx";
import ActivitiesPage from "./components/ActivitiesPage.jsx";

function App() {
  const [activeTab, setActiveTab] = useState("flight");
  const { setOpenModel, email, waiting } = useAuth();
  const location = useLocation();

  // Check if current route is under admin
  const isAdminRoute = location.pathname.startsWith("/admin");

  const renderHomepage = () => {
    switch (activeTab) {
      case "hotel":
        return <Homepage1 />;
      case "flight":
        return <Homepage2 />;
      case "tour":
        return <Homepage3 />;
      default:
        return <Homepage2 />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <FullScreenLoader show={waiting} />
      <ToastContainer />
      <ContactQueryModal open={false} onClose={() => setOpenModel(false)} />

      {/* Conditionally render Navbar and Footer only for non-admin routes */}
      {!isAdminRoute && (
        <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
      )}

      <Routes>
        {/* Public Routes with Navbar & Footer */}
        <Route path="/" element={<>{renderHomepage()}</>} />

        <Route path="/bookings" element={<Bookings />} />
        <Route path="/hotelpage" element={<Homepage1 />} />
        <Route path="/visapage" element={<Homepage3 />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/login" element={<AuthForm />} />
        <Route path="/forget" element={<ForgetPassword />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route
          path="/email-vefication"
          element={<EmailVerificationStatus email={email} />}
        />
        <Route path="/activities" element={<ActivitiesPage />} />
        <Route path="/activity" element={<ActivityBooking />} />
        {/* Admin-only route - NO Navbar/Footer */}
        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
      </Routes>

      {/* Conditionally render Footer only for non-admin routes */}
      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default App;
